import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    width: 280,
    zIndex: 2,
    left: 0,
  }),
  dropdownIndicator: () => ({}),
};

const getOptionValue = (option) => parseInt(option.value);

const getOptionLabel = (option) => (
  <span>
    <span>
      {option.value} {option.t.units}
    </span>
    {option.discount && option.discount.percentage > 0 && (
      <span className="text-success pull-right not-in-preview">
        -{option.discount.percentage}% {option.t.discount}
      </span>
    )}
  </span>
);

const AmountSelectField = (
  { value, onChange, onBlur, discounts, defaultStyles },
  context
) => {
  const discountOptions = discounts.map((discount) => ({
    value: parseInt(discount.amount),
    label: discount.amount,
    discount: discount,
    t: { units: context.t("units"), discount: context.t("discount") },
  }));

  // Find the selected option based on the current value
  const selectedOption =
    discountOptions.find((option) => option.value === value) || null;

  return (
    <Select
      className="amount-select"
      onChange={(selectedOption) => onChange(selectedOption.value)} // Update form value
      onBlur={onBlur} // Notify React Hook Form of blur
      options={discountOptions}
      value={selectedOption || discountOptions[0]} // Default to the first option if no value is selected
      menuPlacement="top"
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      styles={defaultStyles ? {} : customStyles}
      isSearchable={false}
    />
  );
};

AmountSelectField.contextTypes = {
  t: PropTypes.func,
};

AmountSelectField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  discounts: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      discount: PropTypes.shape({
        percentage: PropTypes.number,
      }),
    })
  ).isRequired,
  defaultStyles: PropTypes.bool,
};

export default AmountSelectField;
